module.exports = __webpack_public_path__ + "img/financial_nongye.f121cde7.png";